@if (showLoading) {
    <p-skeleton></p-skeleton>
} @else {
    <div style="display: inline-block; width: calc(100% - 3rem)">
        <p-metergroup [value]="_statusDetail" [pTooltip]="_statusTooltip">
            <ng-template #label></ng-template>
        </p-metergroup>
    </div>
    <div style="display: inline-block; font-weight: normal; width: 3rem; text-align: right">{{ _completionPct }}%</div>
}
